"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_session_store_1 = require("owa-session-store");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isReadingPaneOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var readingPanePositionSelected = owa_options_core_1.getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact);
    var actionAfterMoveKey = optionState.nextSelection || userOptions.NextSelection;
    var showReadingPaneOnFirstLoadSelected = owa_options_core_1.getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad);
    return (readingPanePositionSelected !== userOptions.GlobalReadingPanePositionReact ||
        actionAfterMoveKey !== userOptions.NextSelection ||
        showReadingPaneOnFirstLoadSelected !== userOptions.ShowReadingPaneOnFirstLoad);
});
//# sourceMappingURL=isReadingPaneOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/utils/isReadingPaneOptionDirty.js
// module id = 5123
// module chunks = 2